export enum locationEnum {
    locations = 'Standort'
}